module.exports = __webpack_public_path__ + "img/appleQR.61c634cf.png";